import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';

export const Wrapper = styled.div`
    display: block;
    position: relative;
    width: 100%;
    z-index: 1;
    color: ${p => p.textColor ? p.textColor : 'inherit'};
`;

export const Title = styled.h1`
    display: block;
    ${FONTS.XXL};
    margin-bottom: 12px;
    @media (max-width: 1279px) {
        ${FONTS.L};
    }
    @media (max-width: 530px) {
        ${FONTS.S};
        margin-bottom: 8px;
    }
`;

export const Subtitle = styled.div`
    display: block;
    ${FONTS.H1};
    margin-bottom: 62px;
    @media (max-width: 1279px) {
        ${FONTS.H2};
        margin-bottom: 44px;
    }
    @media (max-width: 530px) {
        ${FONTS.H3};
        margin-bottom: 36px;
    }
`;

export const Button = styled(StyledButton)`
    display: block;
    width: 100%;
    max-width: 312px;
    @media (max-width: 530px) {
        max-width: 100%;
    }
`;

export const Options = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 38px;
    @media (max-width: 1279px) {
        margin-bottom: 22px;
    }
    @media (max-width: 530px) {
        margin-bottom: 18px;
    }
`;
